import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: []
  },
  getters: {
    details: (state) => state.details,
  },
  actions: {
    rejectInvoice({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/Invoice/go-to-reject", id).then((r) => {
            resolve(r.data);
          })
      });
    },
    acceptInvoice({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/Invoices/go-to-confirm" , id)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
      });
    },
    fetchInvoices({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Procurements/api/PurchaseInvoicesQuery/count-of-remaining/" + id)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },

    fetchInvoicesbyId({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Procurements/api/InvoicesQuery/" + id)
          .then((r) => {
            // commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
          });
    },
    fetchSearchSupplier({ commit, dispatch }, name) {
        return new Promise((resolve, reject) => {
          ajax
            .get("Procurements/api/SuppliersQuery/" + name)
            .then(r => {
              resolve(r.data);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
      createInvoice({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Procurements/api/Invoices", model).then((r) => {
            resolve(r.data);
          })
      });
    },
    saveDeductionAndIncrease({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/Invoices/update-deduction-and-increases", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },

    saveSerial({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/Invoices/update-serials-of-items", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },
    saveCurrencyType({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Procurements/api/Invoices/update-currency-info", model).then((r) => {
            resolve(r.data);
          }).catch((e) => console.log(e));
      });
    },
    
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    }
  }
};
